/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // 1. Fix for "Double Click" required to zoom
  // The theme's drag detection has a race condition. It adds 'is-dragging' on mousemove
  // and removes it on mouseup via requestAnimationFrame (async).
  // The 'click' event fires before the class is removed, blocking the zoom.
  // We force remove the class synchronously on mouseup.
  document.addEventListener('mouseup', function(e) {
    var productImages = e.target.closest('product-images');
    if (productImages) {
      productImages.classList.remove('is-dragging');
    }
  }, true); // Capture phase to ensure it runs before the theme's click handler

  // 2. Fix for "Blocked aria-hidden" warning and potential freeze on close
  // Fallback: Ensure scroll lock is removed when closing
  document.addEventListener('click', function(e) {
    // Check if clicking close button or background overlay
    var isCloseBtn = e.target.closest('.pswp__button--close') || e.target.closest('.pswp__caption-close');
    var isAnyButton = e.target.closest('.pswp__button');
    var isBg = e.target.closest('.pswp__bg') || e.target.closest('.pswp__scroll-wrap');
    var isImg = e.target.closest('.pswp__img');
    var isTopBar = e.target.closest('.pswp__top-bar');

    var isBackgroundClick = isBg && !isImg && !isTopBar && !isAnyButton;

    if (isCloseBtn || isBackgroundClick) {
      setTimeout(function() { document.documentElement.removeAttribute('data-scroll-locked'); }, 100);
    }
  }, true);
  
  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
